<template>
  <div class="app-container">
    <div class="mx-2 mt-1">
      <!-- Navbar -->
      <nav class="bg-solimano py-4 px-2 rounded-3">
        <!-- Container wrapper -->
        <div class="d-flex align-items-center justify-content-center">
          <!-- Toggle button -->

          <!-- Collapsible wrapper -->

          <div class="me-auto ms-2 d-flex">
            <!-- Navbar brand -->
            <figure class="my-auto">
              <img
                class="mt-1"
                src="@/assets/Navbarhorizontal/Topas.png"
                height="60"
                width="200"
                alt="MDB Logo"
              />
            </figure>
          </div>
        </div>
      </nav>
      <!-- Navbar -->
    </div>
    <div class="container pt-1">
      <div v-if="!spinner" class="">
        <div class="border border-1 mx-2 px-2 mt-2 border-dark">
          <h5 class="mb-0 pb-0 mt-2">CONTROL DE ACTIVIDADES</h5>
          <p class="mt-0 pt-0 mb-1">MARCACION</p>
        </div>

        <form action="" class="mx-5">
          <div class="form-group-doc d-flex align-items-center mt-2">
            <label style="font-weight: 700" class="me-2">DOC. IDENTIDAD:</label>
            <input
              type="number"
              required
              v-model="numeroDocumento"
              class="form-control p   y-2 mt-1 me-2"
              placeholder="DNI"
              @blur="validarSubSubCentro"
            />
            <button  class="btn btn-primary" @click="mostrarTabla">
              Buscar
            </button>
          </div>

          <div>
    <label for="datepicker">Selecciona una fecha:</label>
    <input
  type="text"
  id="datepicker"
  ref="datepicker"
  class="form-control py-2"
  v-model="fechaSeleccionada"
  placeholder="Seleccionar fecha"
  @input="validarFechaInput"
/>
  </div>
          <div class="form-group mt-2">
            <label style="font-weight: 700">DESCRIPCION :</label>
            <textarea
              v-model="actividad"
              class="form-control mt-1 py-2"
              rows="2"
              placeholder=""
              required
            ></textarea>
          </div>
        </form>

        <!-- <div class="row mt-4 mx-1">
            <button
              class="btn btn-success mt-2 container py-auto h-25 col-12"
              @click="activarCamara"
            >
              <i class="bi bi-camera-video my-auto fs-3"></i
              ><label class="my-2 ms-2">ACTIVAR CAMARA</label>
            </button>
  
            <video
              v-if="videos"
              class="ms-1 col-12"
              ref="video"
              width="100%"
              height="300"
              autoplay
            ></video>
          </div> -->

        <!-- <div class="d-flex">
            <button
              v-if="videos"
              class="btn btn-dark h-25 py-auto w-100"
              @click="tomarFoto"
            >
              <i class="bi bi-camera fs-3 me-2"></i>
              <label class="my-2">TOMAR FOTO</label>
            </button>
            <img
              class="container mt-2"
              width="250"
              height="280"
              :src="fotoCapturada"
              alt="Foto"
              v-if="fotoCapturada && !videos"
            />
          </div> -->
      </div>

      <div v-if="mostrarBotonSubir">
        <div class="w-100 mt-3 text-center">
          <label class="btn btn-primary">
            <i class="bi bi-upload"></i> Seleccionar Fotos
            <input
              type="file"
              multiple
              style="display: none"
              @change="handleMultipleFiles"
            />
          </label>
        </div>

        <div v-if="selectedImages.length" class="image-container text-center">
          <div
            v-for="(image, index) in selectedImages"
            :key="index"
            class="mb-3"
          >
            <img
              :src="image.url"
              alt="Imagen seleccionada"
              class="selected-image"
            />
          </div>
        </div>
      </div>

      <div class="color text-center py-0" v-if="spinner">
        <Spinner class="color py-0 my-0 w-100" />
      </div>

      <button
        @click="RegistrarActividad"
        class="btn btn-success py-3 contianer w-100 mt-3"
      >
        REGISTRO DE ACTIVIDAD
      </button>

      <div v-if="mostrarResultados && dataTable.length > 0" class="mt-4">
        <table class="table table-bordered table-striped table-hover">
          <thead class="table-dark text-center">
            <tr>
              <th>ID</th>
              <th>Fecha</th>
              <th>Descripcion</th>
              <th>Imagen</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="index">
              <td class="text-center">{{ item.idActividad }}</td>
              <td class="text-center">{{ item.fecActividad }}</td>
              <td class="text-center">{{ item.actividad }}</td>
              <td class="text-center">
                  <a
                    :href="
                      url +
                      item.img1.slice(
                        54,
                        item.img1.length
                      )
                    "
                    target="_blank"
                    class="btn btn-ligth my-0"
                  >
                  <i class="bi bi-download"></i>
                  </a>
                </td>
              <td class="text-center">
                <button
                  class="btn btn-danger btn-sm"
                  @click="eliminarActividad(item.idActividad)"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <Footer class="mt-1" />
  </div>
</template>

<script>
import Footer from "@/components/ModSeleccion/Footer/Footer.vue";
import Spinner from "@/views/SpinnerCarga/SpinnerAsistencia.vue";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css"; // Estilo básico de flatpickr
import "flatpickr/dist/themes/material_blue.css"; // Tema opcional, ajusta al diseño nativo


import Swal from "sweetalert2"; // Librería de SweetAlert2

export default {
  components: {
    Footer,
    Spinner,
  },
  data() {
    return {
      actividad: "", // Descripción de la actividad
      numeroDocumento: "", // DNI del trabajador
      fechaSeleccionada: "", // Fecha de la actividad
      img1: "",
      selectedFiles: [], // Archivos seleccionados
      selectedImages: [], // Vista previa de las imágenes seleccionadas
      spinner: false, // Indicador de cargando
      mostrarResultados: false, // Control para mostrar/ocultar la tabla
      dataTable: [], // Datos obtenidos desde la AP
      mostrarBotonSubir: false, // Inicialmente el botón está oculto
    };
  },
  mounted() {

    this.inicializarFlatpickr();
  
    this.axios.get(`ParametroData/Parametro/7704`).then((r) => {
      console.log(r.data);
      this.concepto = r.data;
    });

    
  

  },
  methods: {

    inicializarFlatpickr() {
  if (this.datepickerInstance) {
    this.datepickerInstance.destroy(); // Destruir la instancia anterior si existe
  }

  const feriados = [
  "2025-01-01", // Año Nuevo
  "2025-04-17", // Jueves Santo
  "2025-04-18", // Viernes Santo
  "2025-04-20", // Domingo de Resurrección
  "2025-05-01", // Día Internacional de los Trabajadores
  "2025-06-29", // San Pedro y San Pablo
  "2025-07-23", // Día de la Fuerza Aérea del Perú
  "2025-07-28", // Fiestas Patrias
  "2025-07-29", // Fiestas Patrias
  "2025-08-30", // Santa Rosa de Lima
  "2025-10-08", // Combate de Angamos
  "2025-11-01", // Día de Todos los Santos
  "2025-12-08", // Inmaculada Concepción
  "2025-12-09", // Batalla de Ayacucho
  "2025-12-25", // Navidad
];

  this.$nextTick(() => {
    this.datepickerInstance = flatpickr(this.$refs.datepicker, {
      dateFormat: "d-m-Y", // Formato de fecha
      disable: [
        (date) => {
          const day = date.getDay();
          const formattedDate = date.toISOString().split("T")[0];
          return day === 0 || day === 6 || feriados.includes(formattedDate);
        },
      ],
      locale: {
        firstDayOfWeek: 1, // Lunes como primer día de la semana
      },
      onChange: (selectedDates) => {
        this.fechaSeleccionada = selectedDates.length
          ? selectedDates[0].toISOString().split("T")[0]
          : "";
      },
    });
  });
},

    validarFechaInput() {
      const fecha = new Date(this.fechaSeleccionada);
      const diaSemana = fecha.getDay(); // 0 = Domingo, 6 = Sábado

      if (diaSemana === 0 || diaSemana === 6) {
        this.fechaSeleccionada = "";
        this.$nextTick(() => {
          this.$refs.datepicker.value = "";
        });
        alert("No puedes seleccionar sábados o domingos.");
      }
    },
    reiniciarFormulario() {
      this.fechaSeleccionada = ""; // Limpiar el campo de fecha
      this.$refs.datepicker.value = ""; // Restablecer el input manualmente
    },

    mostrarTabla() {
      // Llamada a la API con promesas
      this.axios
        .get(
          `Asistencia/ListaActividadesxid?nroDeDocumento=${this.numeroDocumento}`
        )
        .then((response) => {
          console.log(response , "data")
          this.dataTable = response.data || []; // Almacena los datos de la API en dataTable
          this.mostrarResultados = true; // Activa la visibilidad de la tabla
        })
        .catch((error) => {
          console.error("Error al consultar la API:", error);
          Swal.fire({
            icon: "error",
            title: "Error al buscar",
            text: "Ocurrió un problema al intentar obtener los datos.",
          });
        });
    },

    handleMultipleFiles(event) {
      const files = event.target.files;
      const newFiles = Array.from(files); // Convertir FileList a Array

      // Validar que el total de archivos seleccionados no exceda 
      if (newFiles.length + this.selectedFiles.length > 4) {
        Swal.fire({
          icon: "error",
          title: "Límite de imágenes excedido",
          text: "Solo puedes subir un máximo de 4 imágenes.",
        });
        return; // Detener si se excede el límite
      }

      // Agregar los nuevos archivos al array `selectedFiles`
      this.selectedFiles.push(...newFiles);

      // Generar vistas previas de las imágenes
      this.selectedImages = this.selectedFiles.map((file) => {
        console.log("Archivo cargado:", file); // Mostrar el nombre del archivo en consola
        return {
          file,
          url: URL.createObjectURL(file),
        };
      });
    },
    RegistrarActividad() {
      console.log("Archivo seleccionado:", this.selectedFiles); // Debug
      console.log("Descripción de actividad:", this.actividad); // Debug

      this.spinner = true; // Mostrar spinner de cargando
      console.log(this.selectedFiles);
      // Crear el objeto JSON para enviar los datos
      const formData = new FormData();
      formData.append("nroDocumento", this.numeroDocumento);
      formData.append("actividad", this.actividad);
      formData.append("fecActividad", this.fechaSeleccionada);
      this.selectedFiles.forEach((file, index) => {
        console.log(`Archivo[${index}]`, file);
        formData.append("Archivos", file); // Misma clave "Archivos"
      });

      // Enviar la solicitud POST a la API
      this.axios
        .post(
          "Asistencia/RegistrarActividad",
          formData, // Enviar los datos como un objeto JSON
          {
            headers: {
              "Content-Type": "multipart/form-data", // Especificar que se enviará JSON
            },
          }
        )
        .then((response) => {
          // Manejar la respuesta exitosa
          this.spinner = false; // Ocultar spinner
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: `${response.data}`, // Mostrar mensaje de éxito
            showConfirmButton: true,
            timer: 4500,
          });
          
          this.actividad = "";
          this.fechaSeleccionada = "";
          this.selectedFiles = [];
          this.selectedImages = [];
          this.inicializarFlatpickr();
          this.mostrarTabla(); 



          
          // Vaciar el array de archivos
        })
        .catch((error) => {
          // Manejar errores
          console.error(error);
          alert(
            "Error al registrar actividad: " +
              (error.response?.data || error.message)
          );
          this.spinner = false; // Ocultar spinner
        });
    },

    validarSubSubCentro() {
      this.axios
        .get(
          `Asistencia/ValidarSubSubCentro?nroDeDocumento=${this.numeroDocumento}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.mostrarBotonSubir = true;
            console.log("si"); // Mostrar botón si el valor es correcto
          } else {
            this.mostrarBotonSubir = false; // Ocultar botón si no es válido
          }
        })
        .catch((error) => {
          console.error("Error al validar SubSubCentro:", error);
          this.mostrarBotonSubir = false;
        });
    },
    eliminarActividad(idActividad) {
      // Muestra un mensaje de confirmación antes de ejecutar la acción
      Swal.fire({
        title: "¿Estás seguro?",
        text: "Se actualizarán los valores de la actividad seleccionada.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Eliminar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinner = true; // Mostrar spinner de cargando

          // Llamada a la API con Axios
          this.axios
            .put(
              `Asistencia/EditarActividad?idActividad=${idActividad}`
            )
            .then((response) => {
              this.spinner = false; // Ocultar spinner
              Swal.fire({
                icon: "success",
                title: "Actividad actualizada",
                text: response.data,
              });

              // Refrescar la tabla de actividades (opcional)
              this.actividad = "";
          this.fechaSeleccionada = "";
          this.selectedFiles = [];
          this.selectedImages = [];
          this.inicializarFlatpickr();
              this.mostrarTabla();
            })
            .catch((error) => {
              this.spinner = false; // Ocultar spinner
              console.error("Error al actualizar la actividad:", error);
              Swal.fire({
                icon: "error",
                title: "Error",
                text:
                  error.response?.data ||
                  "Ocurrió un problema al actualizar la actividad.",
              });
            });
        }
      });
    },

    validarFecha() {
    if (this.fechaSeleccionada) {
      const fecha = new Date(this.fechaSeleccionada);
      const diaSemana = fecha.getDay(); // 0 = Domingo, 6 = Sábado

      if (diaSemana === 0 || diaSemana === 6) {
        Swal.fire({
          icon: "error",
          title: "Fecha no válida",
          text: "No puedes seleccionar sábados o domingos.",
        });
        this.fechaSeleccionada = ""; // Limpia la fecha seleccionada
      }
    }
  },
  },
};
</script>

<style scoped>
.bg-solimano {
  background: #002c5d;
}

.image-container {
  margin-top: 20px;
}

.selected-image {
  max-width: 400px; /* Ajusta el tamaño según tus necesidades */
  max-height: 300px; /* Ajusta el tamaño según tus necesidades */
  border: 1px solid #ddd; /* Añade un borde opcional */
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-container > .container {
  flex: 1;
}
.form-group-doc {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.form-group-doc .form-control {
  flex: 1; /* Esto hace que el campo ocupe el espacio disponible */
}

.form-group-doc button {
  margin-left: 10px; /* Espacio entre el campo y el botón */
}
.color {
  background: #fffafa;
}

.form-control {
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  padding: 8px 12px;
  width: 100%;
  box-sizing: border-box;
}

.flatpickr-input {
  border: none; /* Remueve los bordes duplicados */
  background: inherit; /* Usa el fondo del contenedor */
}

.flatpickr-calendar {
  z-index: 1000; /* Asegura que el calendario se muestre sobre otros elementos */
}
</style>
